import { render, staticRenderFns } from "./Homeworks.vue?vue&type=template&id=da1ea3b6&scoped=true&"
import script from "./Homeworks.vue?vue&type=script&lang=js&"
export * from "./Homeworks.vue?vue&type=script&lang=js&"
import style0 from "./Homeworks.vue?vue&type=style&index=0&id=da1ea3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1ea3b6",
  null
  
)

export default component.exports